import React from "react";
// import { wxConfig } from "../../utils/wxConfig";
// import wx from "wx";
import { post } from "../utils/request";
import api from "./api";

class Transfer extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {};
    }

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin:
                u.indexOf("micromessenger") > -1 ||
                u.match(/weixin*/i) ||
                u.match(/wechat*/i),
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是a:否web应该程序，没有头部与底部
            isHlApp:
                u.indexOf("com.ehuodi.mobile.huilian.test") > -1 ||
                u.indexOf("com.ehuodi.mobile.huilian") > -1 ||
                u.indexOf("TFHuiLian") > -1 ||
                u.match(/huilian*/i), //是否远程慧联app
        };
    };

    componentDidMount() {
        window.href = this.href;
        var obj = "",
            obj1 = "",
            ops = {};
        let viewPort = this.viewPort();
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            if (!viewPort.isHlApp) {
                if (ops.type === "H5") {
                    window.location.replace(decodeURIComponent(ops.QRCode));
                } else if (ops.type === "MAINTENANCE_BOOKINGS") {
                    const text = `fromScanningPage=true&supplierBranchCode=${ops.QRCode}`;
                    const url = `https://test.lvsehuilian.cn/payment/#/demo?${text}`;
                    if (
                        window.location.origin.indexOf("hellogil.com") > -1 ||
                        window.location.origin.indexOf("www.lvsehuilian.cn") >
                            -1
                    ) {
                        this.getWXUrl(
                            "pages/maintenance-reserve/maintenance-reserve",
                            `cq=${encodeURIComponent(text)}`
                        );
                    } else {
                        this.getWXUrl(
                            "pages/maintenance-reserve/maintenance-reserve",
                            `cq=${encodeURIComponent(text)}`
                        );
                        // this.getWXUrl(
                        //     "pages/webview/h5",
                        //     `url=${encodeURIComponent(url)}`
                        // );
                    }
                } else {
                    window.location.replace(
                        "https://www.hellogil.com/appDownload/#/HuilianDownload"
                    );
                }
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {}
            );
        }
    }
    async getWXUrl(path, query) {
        const res = await post({
            url: api.generateUrlLink,
            data: {
                appKey: "wx_lshl",
                path: path,
                query: query,
                envVersion:
                    window.location.origin.indexOf("hellogil.com") > -1 ||
                    window.location.origin.indexOf("www.lvsehuilian.cn") > -1
                        ? "release"
                        : "trial",
            },
        });
        if (!(res && res.data)) {
            window.location.replace(
                "https://www.hellogil.com/appDownload/#/HuilianDownload"
            );
        } else {
            window.location.replace(res.data);
        }
    }

    componentWillMount() {}

    render() {
        return <div></div>;
    }
}
export default Transfer;



// WEBPACK FOOTER //
// ./src/transferQr/index.js